import { UserNotificationStatus } from 'dashboard/models/user-notification';

export const INBOX_REQUEST_KEY = UserNotificationStatus.Delivered;
export const ARCHIVED_REQUEST_KEY = UserNotificationStatus.Archived;
const REQUEST_KEYS = [INBOX_REQUEST_KEY, ARCHIVED_REQUEST_KEY];

export type RequestKey = (typeof REQUEST_KEYS)[number];
